import React from 'react';
import { useTranslation } from 'next-i18next';
import Link from 'next/link';
import { trackApplyButton } from '@/utils/dataLayer';
import { HiOutlineMapPin } from "react-icons/hi2";
import { IoMailOutline } from "react-icons/io5";
import { FiPhone } from "react-icons/fi";

const BranchesInfoHero = () => {
    const { t } = useTranslation();

    return (
        <div className="w-full bg-white">
            <div className="max-w-[98%] lg:max-w-[90%] mx-auto px-[15px] md:px-4 lg:px-0 py-[40px] md:py-[100px]">
                <div className="flex flex-col lg:flex-row gap-[30px] md:gap-[40px] lg:gap-[50px]">
                    <div className="flex-1 flex flex-col gap-[12px] md:gap-[20px]">
                        <span className="text-[20px] md:text-[28px] font-[600] text-transparent bg-clip-text bg-gradient-to-b from-[#091F59] to-[#1A3884]">
                            {t('branches-page.branches')}
                        </span>

                        <h1 className="text-[32px] md:text-[64px] xl:text-[80px] font-[500] text-transparent bg-clip-text bg-gradient-to-b from-[#091F59] to-[#1A3884] leading-tight">
                            Peerstack Academy
                        </h1>

                        <div className="flex flex-col lg:flex-row justify-between flex-wrap gap-[20px]">
                            <div className="flex flex-col max-w-full lg:max-w-[70%] gap-[24px]">
                                <div className="flex items-center space-x-3">
                                    <div className="min-w-[46px] min-h-[46px] bg-white rounded-full flex items-center justify-center shadow-[0px_4px_10px_0px_rgba(0,0,0,0.1)]">
                                        <HiOutlineMapPin className="text-[#1053F3] text-[24px]" />
                                    </div>
                                    <span className="text-black text-[14px]">{t('address')}</span>
                                </div>

                                <div className="flex items-center space-x-3 min-w-[200px]">
                                    <div className="min-w-[46px] min-h-[46px] bg-white rounded-full flex items-center justify-center shadow-[0px_4px_10px_0px_rgba(0,0,0,0.1)]">
                                        <IoMailOutline className="text-[#1053F3] text-[24px]" />
                                    </div>
                                    <Link href="mailto:info@peerstack.tech" className="text-black text-[14px] hover:underline focus:outline-none focus:underline underline-offset-4">info@peerstack.tech</Link>
                                </div>

                                <div className="flex items-center space-x-3 min-w-[200px]">
                                    <div className="min-w-[46px] min-h-[46px] bg-white rounded-full flex items-center justify-center shadow-[0px_4px_10px_0px_rgba(0,0,0,0.1)]">
                                        <FiPhone className="text-[#1053F3] text-[24px]" />
                                    </div>
                                    <Link href="tel:+994552508887" className="text-black text-[14px] hover:underline focus:outline-none focus:underline underline-offset-4">+99455 250 88 87</Link>
                                </div>
                            </div>
                        </div>

                        <Link
                            href="/apply"
                            className="mt-auto w-full md:w-auto"
                            onClick={() => trackApplyButton("branches_hero")}
                        >
                            <button className="w-full md:w-[200px] lg:w-[235px] h-[48px] md:h-[56px] bg-main-pink border border-main-pink text-white text-[16px] font-semibold rounded-full hover:bg-white hover:text-main-pink transition-colors duration-300">
                                {t('apply-btn')}
                            </button>
                        </Link>
                    </div>

                    <div className="flex-1 w-full lg:min-h-[500px]">
                        <iframe
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3039.749102118088!2d49.812972912187206!3d40.37008727132805!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40307da8ecebea85%3A0x347a3663d6f94b4d!2sPeerstack%20Academy!5e0!3m2!1str!2saz!4v1766732433157!5m2!1str!2saz"
                            className="w-full h-[400px] md:h-[450px] lg:h-full min-h-[400px] rounded-[24px] border border-[#E0E0E0]"
                            allowFullScreen=""
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                            title="Peerstack Academy Location"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BranchesInfoHero;
